import { FileTypeEnum as e } from "@systemeio/types";
//#region src/enums/file-type-enum.ts
var t = {
	[e.Image]: "file_manager.file_type.image",
	[e.ImageOther]: "file_manager.file_type.image_other",
	[e.Video]: "file_manager.file_type.video",
	[e.Audio]: "file_manager.file_type.audio",
	[e.Font]: "file_manager.file_type.font",
	[e.Document]: "file_manager.file_type.document"
};
//#endregion
export { e as FileTypeEnum, t as FileTypeEnumLocoKeys };
